import React from 'react';
import { QuizPage } from '../components/QuizPage';
export function AdSpendComfort({
  onAnswer
}: {
  onAnswer: (ans: string, dq: boolean) => void;
}) {
  return <QuizPage stepNumber={7} question="If we work together, how comfortable would you be funding at least $2k/month in ad spend?" options={[{
    label: 'Very comfortable'
  }, {
    label: 'Comfortable'
  }, {
    label: 'Could stretch to it'
  }, {
    label: 'Not comfortable',
    isDq: true
  }]} onSelect={opt => onAnswer(opt.label, !!opt.isDq)} data-id="element-146" />;
}